/**
 *
 * SRM 采购管理系统
 *
 */

import { commonPromise } from '../index.js'

// 跨域代理前缀
// const API_PROXY_PREFIX = '/api'
const API_PROXY_PREFIX = ''
const BASE_URL = process.env.NODE_ENV === 'production' ? process.env.VUE_APP_API_BASE_URL : API_PROXY_PREFIX
// const BASE_URL = process.env.VUE_APP_API_BASE_URL

const srmApi = {
  // dictionariesOld123: (params) => commonPromise({ params, url: `${BASE_URL}/sys/v1/common/win/type`, method: 'get' }), // 字典查询 old
  // statistics: (data) => commonPromise({ data, url: `${BASE_URL}/report/home/sales/data/statistics`, method: 'post' }), // 首页销售数据统计
  srmSupplierPage: (data) => commonPromise({ data, url: `${BASE_URL}/goods/supplier/page`, method: 'post' }), // 分页查询供应商列表
  srmSupplierList: (data) => commonPromise({ data, url: `${BASE_URL}/goods/supplier/list`, method: 'post' }), // 查询供应商列表
  srmSupplierGet: (data) => commonPromise({ data, url: `${BASE_URL}/goods/supplier/get`, method: 'get' }), // 根据ID获取供应商详情
  srmSupplierAdd: (data) => commonPromise({ data, url: `${BASE_URL}/goods/supplier/add`, method: 'post' }), // 新增供应商
  srmSupplierEdit: (data) => commonPromise({ data, url: `${BASE_URL}/goods/supplier/edit`, method: 'post' }), // 修改供应商
  srmSupplierRemove: (data) => commonPromise({ data, url: `${BASE_URL}/goods/supplier/remove`, method: 'post' }), // 删除供应商
  srmSupplierExport: (data) => commonPromise({ data, url: `${BASE_URL}/goods/supplier/export`, method: 'post' }), // 导出供应商列表

  // 采购订单
  srmSurchaseOrderPage: (data) => commonPromise({ data, url: `${BASE_URL}/goods/purchase/order/page`, method: 'post' }), // 分页查询采购订单列表
  srmSurchaseOrderAdd: (data) => commonPromise({ data, url: `${BASE_URL}/goods/purchase/order/add`, method: 'post' }), // 新增销售商品采购订单
  srmSurchaseOrderDetail: (data) => commonPromise({ data, url: `${BASE_URL}/goods/purchase/order/detail`, method: 'post' }), // 查询采购订单详情
  srmSurchaseOrderEdit: (data) => commonPromise({ data, url: `${BASE_URL}/goods/purchase/order/edit`, method: 'post' }), // 编辑采购订单详情
  srmSurchaseOrderEffect: (data) => commonPromise({ data, url: `${BASE_URL}/goods/purchase/order/effect`, method: 'post' }), // 生效采购订单
  srmSurchaseOrderInvalid: (data) => commonPromise({ data, url: `${BASE_URL}/goods/purchase/order/invalid`, method: 'post' }), // 作废采购订单
  srmSurchaseOrderExport: (data) => commonPromise({ data, url: `${BASE_URL}/goods/purchase/order/export`, method: 'post' }), // 导出采购订单
  srmSurchaseOrderDelete: (data) => commonPromise({ data, url: `${BASE_URL}/goods/purchase/order/delete`, method: 'post' }), // 删除采购订单
  workflowTimeLine: (params) => commonPromise({ params, url: `${BASE_URL}/oa/workflow-process/getTimeLine`, method: 'get' }), //获取时间轴详情
  
  // 退货订单
  srmReturnOrderPage: (data) => commonPromise({ data, url: `${BASE_URL}/goods/purchase/return-order/page`, method: 'post' }), // 分页查询采购退货订单列表
  srmReturnOrderAdd: (data) => commonPromise({ data, url: `${BASE_URL}/goods/purchase/return-order/add`, method: 'post' }), // 新增采购退货订单
  srmReturnOrderDetail: (data) => commonPromise({ data, url: `${BASE_URL}/goods/purchase/return-order/detail`, method: 'post' }), // 查询采购退货订单详情
  srmReturnOrderEdit: (data) => commonPromise({ data, url: `${BASE_URL}/goods/purchase/return-order/edit`, method: 'post' }), // 编辑采购退货订单
  srmReturnOrderEffect: (data) => commonPromise({ data, url: `${BASE_URL}/goods/purchase/return-order/effect`, method: 'post' }), // 生效采购退货订单
  srmReturnOrderExport: (data) => commonPromise({ data, url: `${BASE_URL}/goods/purchase/return-order/export`, method: 'post' }), // 导出采购退货订单
  srmReturnOrderDelete: (data) => commonPromise({ data, url: `${BASE_URL}/goods/purchase/return-order/delete`, method: 'post' }), // 删除退货订单
}

export default srmApi
